import { Link } from "react-router-dom";
import styles from "./style/Game.module.css";
import Menu from "./menu.png";
import Music from "./image15.png";
import Arcaea from "./game/arcaea.png";
import Cytus from "./game/cytus2.png";
import Phigros from "./game/phigros.png";
import Deemo from "./game/deemo.png";
import Lanota from "./game/lanota.png";
import Maimai from "./game/maimai.png";
import Dynamix from "./game/dynamix.png";
import ProjectSEKAI from "./game/project.png";
import Musedash from "./game/musedash.png";
import Chunithm from "./game/chunithm.png";
import Osu from "./game/osu.png";
import Bangdream from "./game/bangdream.png";

function ChangeContent1() {
  let menu = document.getElementById("Menu");
  menu.style.height = "100vh";
}

function ChangeContent2() {
  let menu = document.getElementById("Menu");
  menu.style.height = "0";
}

function GameImage(props) {
  return (
    <div className = {styles.GameImage}>
      <img className = {styles.gameimg} src={props.Image} />
      <span className = {styles.gametext}>{props.Name}</span>
    </div>
  );
}

function Game() {
  return (
    <div className={styles.main}>
      <div className={styles.menu} id="Menu">
        <div className={styles.menutitle}>
          <Link to="/" className={styles.menutitletext}>
            <div>Rhythm with Game</div>
          </Link>
          <img
            src={Menu}
            className={styles.menuimg}
            id="icon"
            onClick={ChangeContent2}
          />
        </div>
        <div className={styles.menutext}>A playable website for music</div>
        <Link to="/introduction" className={styles.link}>
          <div>Introduction</div>
        </Link>
        <div className={styles.speciallink} onClick={ChangeContent2}>
          Games
        </div>
        <Link to="/story" className={styles.link}>
          <div>Creator’s Story</div>
        </Link>
        <Link to="/music" className={styles.link}>
          <div>
            <img src={Music} /> Enjoy the Music
          </div>
        </Link>
      </div>
      <div className={styles.original} id="Original">
        <div className={styles.title}>
          <div className={styles.titletext}>Games</div>
          <img src={Menu} className={styles.img} onClick={ChangeContent1} />
        </div>
        <div className={styles.GameContainer}>
        <Link to="/arcaea">
        <GameImage Image={Arcaea} Name="Arcaea" />
        </Link>
        <GameImage Image={Cytus} Name="Cytus II" />
        <GameImage Image={Phigros} Name="Phigros" />
        <GameImage Image={Deemo} Name="Deemo" />
        <GameImage Image={Lanota} Name="Lanota" />
        <GameImage Image={Dynamix} Name="Dynamix" />
        <GameImage Image={Maimai} Name="MaiMai DX" />
        <GameImage Image={Chunithm} Name="CHUNITHM" />
        <GameImage Image={Osu} Name="OSU!" />
        <GameImage Image={Musedash} Name="Muse Dash" />
        <GameImage Image={ProjectSEKAI} Name="Project SEKAI" />
        <GameImage Image={Bangdream} Name="BanG Dream!" />
        </div>
        <div className={styles.text}></div>
      </div>
    </div>
  );
}

export default Game;
